<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Agendar Encontro' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding class="forms-validations-content">
  <div class="gradient-extendido"></div>

  <ion-card-content>
    <form
      class="sample-form validations-form"
      [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)"
    >
      <ion-list class="card-preferences">
        <prover-datepicker
          [labelName]="'Data'"
          [id]="'data'"
          formControlName="data"
          [required]="true"
        ></prover-datepicker>
        <div class="validation-errors ion-margin-start">
          <ng-container *ngFor="let validation of validation_messages.data">
            <div
              class="error-message"
              *ngIf="validations_form.get('data')?.hasError(validation.type) && (validations_form.get('data')?.dirty || validations_form.get('data')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <app-prover-horas
          [labelName]="'Hora'"
          [id]="'hora'"
          formControlName="hora"
          [required]="true"
          [isLabel]="true"
        ></app-prover-horas>
        <div class="validation-errors ion-margin-start">
          <ng-container *ngFor="let validation of validation_messages.hora">
            <div
              class="error-message"
              *ngIf="validations_form.get('hora')?.hasError(validation.type) && (validations_form.get('hora')?.dirty || validations_form.get('hora')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <div class="ion-margin-start ion-margin-top border-bottom">
          <ion-label labelPlacement="stacked"> {{'Descrição' | translate}} <span class="danger">*</span> </ion-label>
          <ion-textarea
            placeholder="{{'Descrição do encontro' | translate}}"
            rows="5"
            type="text"
            formControlName="descricao"
          ></ion-textarea>
        </div>
        <div class="validation-errors ion-margin-start">
          <ng-container *ngFor="let validation of validation_messages.descricao">
            <div
              class="error-message"
              *ngIf="validations_form.get('descricao')?.hasError(validation.type) && (validations_form.get('descricao')?.dirty || validations_form.get('descricao')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <div class="ion-margin-start ion-margin-top" *ngIf="showStatus">
          <ion-select
            interface="action-sheet"
            cancelText="{{ 'Cancelar' | translate}}"
            okText="{{ 'Confirmar' | translate}}"
            formControlName="status"
          >
            <div slot="label">{{'Status' | translate}} <span class="danger">*</span></div>
            <ion-select-option *ngFor="let status of statusList" [value]="status.id">
              {{status.nome}}
            </ion-select-option>
          </ion-select>
        </div>
      </ion-list>

      <ion-row class="d-flex ion-margin-top">
        <ion-col size="8" class="d-flex">
          <ion-button class="btn-success btn-custom" expand="block" type="submit" [disabled]="!validations_form.valid">
            {{'Salvar' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </form>
  </ion-card-content>
</ion-content>
